var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"dense":"","flat":"","color":"#ffffff"}},[_c('v-toolbar-title')],1)}
var staticRenderFns = []

export { render, staticRenderFns }